/**
 * Le son propre à l'avant-séance, celui de l'ancien écran : la mélodie du test des haut-parleurs. Ceux de
 * Sam (son arrivée, une réponse touchée, « C'est parti ! », le pétale) sont partagés : `SAM_SOUNDS`.
 */
/* eslint-disable @typescript-eslint/no-require-imports */
export const LIVE_ENTRY_SOUNDS = {
    chime: require("../../../../../../../assets/sounds/confirmation_002.mp3") as number,
}
/* eslint-enable @typescript-eslint/no-require-imports */
